import React from "react";
import Footer from "../components/Footer";
import SubHeader from "../components/SubHeader";

function Hanthanarange() {
  return (
    <>
      <SubHeader />
      <main>
        <section className="page-header">
          <div className="page-header__bg" />
          {/* /.page-header__bg */}
          <div className="container">
            <ul className="villoz-breadcrumb list-unstyled">
              <li>
                <a href="index.html">Home</a>
              </li>
              <li>
                <span>Activities</span>
              </li>
              <li>
                <span>Hanthana Mountain Range Hiking &amp; Trekking</span>
              </li>
            </ul>
            {/* /.thm-breadcrumb list-unstyled */}
            <h2 className="page-header__title">
              Hanthana Mountain Range Hiking &amp; Trekking
            </h2>
          </div>
          {/* /.container */}
        </section>
        {/* /.page-header */}
        <section className="destinations-details">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="destinations-details__image">
                  <img
                    src="assets/images/activities/hanthanarange/main.webp?v=20260924"
                    alt="villoz"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="destinations-details__content">
                  <h3 className="destinations-details__title">
                    Hanthana Mountain Range Hiking &amp; Trekking
                  </h3>
                  <p className="destinations-details__text">
                    The Hanthana Mountain Range is a must-visit destination for
                    trekking and hiking enthusiasts. Hiking the Mountain Range
                    is a rewarding experience for anyone who is keen about
                    nature and wildlife. There are multiple trails to choose
                    from, ranging from beginner-friendly paths to more
                    challenging routes and a typical trek can take 4-6 hours,
                    depending on the route and pace, making it ideal for a day
                    of exploring nature. The journey begins at Hanthana House,
                    where either one of our naturalists or a well-experienced
                    trekker will guide you through this remarkable expedition.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="gallery-three">
          <div className="container">
            <div
              className="gallery-three__carousel villoz-owl__carousel  villoz-owl__carousel--basic-nav owl-carousel owl-theme"
              data-owl-options='{
			"items": 5,
			"margin": 30,
			"loop": false,
			"smartSpeed": 700,
			"nav": false,
			"navText": ["<span class=\"fa fa-angle-left\"></span>","<span class=\"fa fa-angle-right\"></span>"],
			"dots": false,
			"autoplay": true,
			"responsive": {
				"0": {
					"items": 1
				},
				"360": {
					"items": 2,
					"margin": 20
				},
				"575": {
					"items": 3
				},
				"992": {
					"items": 4
				},
				"1200": {
              "margin": 42,
					"items": 5
				}
			}
			}'
            >
              <div className="item">
                <div className="gallery-three__card">
                  <img
                    src="assets/images/activities/hanthanarange/1.webp?v=20260924"
                    alt=""
                  />
                  <div className="gallery-three__card__hover">
                    <a
                      href="assets/images/activities/hanthanarange/1.webp?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-three__card__icon" />
                    </a>
                  </div>
                  {/* /.gallery-three__card__hover */}
                </div>
                {/* /.gallery-three__card */}
              </div>
              {/* /.col-md-6 col-lg-4 */}
              <div className="item">
                <div className="gallery-three__card">
                  <img
                    src="assets/images/activities/hanthanarange/2.webp?v=20260924"
                    alt=""
                  />
                  <div className="gallery-three__card__hover">
                    <a
                      href="assets/images/activities/hanthanarange/2.webp?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-three__card__icon" />
                    </a>
                  </div>
                  {/* /.gallery-three__card__hover */}
                </div>
                {/* /.gallery-three__card */}
              </div>
              {/* /.col-md-6 col-lg-4 */}
              <div className="item">
                <div className="gallery-three__card">
                  <img
                    src="assets/images/activities/hanthanarange/3.webp?v=20260924"
                    alt=""
                  />
                  <div className="gallery-three__card__hover">
                    <a
                      href="assets/images/activities/hanthanarange/3.webp?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-three__card__icon" />
                    </a>
                  </div>
                  {/* /.gallery-three__card__hover */}
                </div>
                {/* /.gallery-three__card */}
              </div>
              {/* /.col-md-6 col-lg-4 */}
              <div className="item">
                <div className="gallery-three__card">
                  <img
                    src="assets/images/activities/hanthanarange/4.webp?v=20260924"
                    alt=""
                  />
                  <div className="gallery-three__card__hover">
                    <a
                      href="assets/images/activities/hanthanarange/4.webp?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-three__card__icon" />
                    </a>
                  </div>
                  {/* /.gallery-three__card__hover */}
                </div>
                {/* /.gallery-three__card */}
              </div>
              {/* /.col-md-6 col-lg-4 */}
              <div className="item">
                <div className="gallery-three__card">
                  <img
                    src="assets/images/activities/hanthanarange/5.webp?v=20260924"
                    alt=""
                  />
                  <div className="gallery-three__card__hover">
                    <a
                      href="assets/images/activities/hanthanarange/5.webp?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-three__card__icon" />
                    </a>
                  </div>
                  {/* /.gallery-three__card__hover */}
                </div>
                {/* /.gallery-three__card */}
              </div>
              {/* /.col-md-6 col-lg-4 */}
            </div>
            {/* /.gallery-three__carousel */}
          </div>
          {/* /.container */}
        </section>
        {/* /.gallery-three */}
      </main>
      <Footer />
    </>
  );
}

export default Hanthanarange;
